import { config } from "../../config";

// Sales channels are created and edited in the new admin (heapsgo-admin-web);
// drinks-admin only shows them and links there.
const salesChannelsUrl = (organizationKeyName: string, shopId: string) =>
  `${config.heapsGoAdminUrl}/hgo/${organizationKeyName}/shops/${shopId}/sales-channels`;

export const heapsGoAdminSalesChannelUrl = (
  organizationKeyName: string,
  shopId: string,
  salesChannelId: string
) => `${salesChannelsUrl(organizationKeyName, shopId)}/${salesChannelId}`;

export const heapsGoAdminNewSalesChannelUrl = (
  organizationKeyName: string,
  shopId: string
) => `${salesChannelsUrl(organizationKeyName, shopId)}/new`;
